import { Container, Row, Col, Text } from '@qonsoll/react-design'
import { RoleList } from '../../../Role/components'
import { useGetCustomerProfileRoles } from '../../hooks'
import PropTypes from 'prop-types'
import { Spinner } from 'components'
import { useTranslations } from 'contexts/Translation'

export default function CustomerProfileRoles(props) {
  const { customerProfile } = props

  // [ADDITIONAL_HOOKS]
  const [roles, loading] = useGetCustomerProfileRoles(customerProfile)
  const { t } = useTranslations()

  return (
    <Container>
      <Row noGutters>
        <Col>
          {loading ? (
            <Spinner flex={1} />
          ) : roles?.length ? (
            <RoleList {...props} hideAddCard roles={roles} />
          ) : (
            <Text type="secondary" variant="overline">
              {t('No roles have been added yet')}
            </Text>
          )}
        </Col>
      </Row>
    </Container>
  )
}

CustomerProfileRoles.propTypes = {
  customerProfile: PropTypes.object.isRequired
}
